import React from "react";
import { useTranslation } from "react-i18next";
import { DEFAULT_SIZE } from "./constants";
import { LoaderCircle } from "lucide-react";

const Loader = ({
  size = DEFAULT_SIZE,
  dots = false,
  withContainer = false,
}) => {
  const { t: translate, i18n } = useTranslation();

  let loaderComponent = null;
  if (dots) {
    loaderComponent = (
      <div className="inline ">
        <div className="flex space-x-2 justify-center items-center bg-transparent z-50">
          <span className="sr-only">{translate("shared.loading")}</span>
          <div className="h-3 w-3 bg-primary-300 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-3 w-3 bg-primary-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-3 w-3 bg-primary-500 rounded-full animate-bounce"></div>
        </div>
      </div>
    );
  } else {
    loaderComponent = (
      <LoaderCircle
        className={`inline w-${size} h-${size} text-gray-200 animate-spin dark:text-white fill-[#1f2937]`}
      />
    );
  }

  if (withContainer) {
    return (
      <div className="fixed top-0 left-0 w-screen h-dvh bg-black opacity-50 flex justify-center items-center z-50">
        {loaderComponent}
      </div>
    );
  } else {
    return loaderComponent;
  }
};

export default Loader;
